// extracted by mini-css-extract-plugin
module.exports = {"TasksCompleted":"TasksCompleted_TasksCompleted__2a5K0","TasksCompletedList":"TasksCompleted_TasksCompletedList__2QxaN","taskCompleted":"TasksCompleted_taskCompleted__1NU_0"};